<template>
    <div class="bg-blue py-20 overflow-hidden">
      <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12">
        <div class="grid grid-cols-1 lg:grid-cols-2 items-center strategic-card">
          <!-- Left Image Section -->
          <div class="flex justify-center">
            <div class="overflow-hidden h-[600px]">
              <img
                src="../assets/images/tower.png"
                alt="Our Story"
                class="w-full h-full transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>
  
          <!-- Right Content Section -->
          <div class="p-8 lg:p-10 animate-fadeIn">
            <p class="text-white text-sm leading-relaxed mb-4 mt-5">
              Incorporated in September 2018, Mshel Homes Limited is a leading real estate development and construction company with nearly a decade of experience. Under the visionary leadership of Group Managing Director, Arc. Dr. Barka U. Mshelia, Mshel Homes has made significant strides in building construction, housing estates, infrastructural development, and real estate consultancy services.
            </p>
            <p class="text-white text-sm leading-relaxed mb-4">
                Mshel Homes Ltd is renowned as the leading developer of shell finish properties, offering a diverse range of apartments, terraces, and duplexes. 
            </p>
  
            <!-- Milestone Section -->
            <div class="grid grid-cols-2 md:grid-cols-3 gap-6 mt-10" ref="stats">
            <div class="text-center">
              <img src="../assets/images/town_2590504.png" class="h-12 mx-auto filter invert" alt="" />
              <h3 class="text-yellow text-2xl font-bold mt-2"><span>{{ properties }}</span>+</h3>
              <p class="text-white">Properties</p>
            </div>
            <div class="text-center">
              <img src="../assets/images/worker.png" class="h-12 mx-auto filter invert" alt="" />
              <h3 class="text-yellow text-2xl font-bold mt-2"><span>{{ engineers }}</span>+</h3>
              <p class="text-white">Site Engineers</p>
            </div>
            <div class="text-center">
              <img src="../assets/images/teamwork_3281785.png" class="h-12 mx-auto filter invert" alt="" />
              <h3 class="text-yellow text-2xl font-bold mt-2"><span>{{ staff }}</span>+</h3>
              <p class="text-white">Office Staff</p>
            </div>
            <div class="text-center">
              <img src="../assets/images/location (1).png" class="h-12 mx-auto filter invert" alt="" />
              <h3 class="text-yellow text-2xl font-bold mt-2"><span>{{ location}}</span>+</h3>
              <p class="text-white">Locations</p>
            </div>
            <div class="text-center col-span-2 md:col-span-1">
              <img src="../assets/images/payment-method.png" class="h-12 mx-auto filter invert" alt="" />
              <h3 class="text-yellow text-2xl font-bold mt-2"><span>{{ realty }}</span>B+</h3>
              <p class="text-white">Paid out in Realty</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        properties: 0,
        engineers: 0,
        staff: 0,
        location: 0,
        realty: 0,
      };
    },
    methods: {
  animateCounters() {
    const targets = {
      properties: 2000,
      engineers: 60,
      staff: 200,
      location: 39,
      realty: 1,
    };

    // Reset counters to 0 before animating again
    Object.keys(targets).forEach((key) => {
      this[key] = 0;
    });

    Object.keys(targets).forEach((key) => {
      let count = 0;
      const step = Math.ceil(targets[key] / 100);
      const interval = setInterval(() => {
        count += step;
        if (count >= targets[key]) {
          this[key] = targets[key];
          clearInterval(interval);
        } else {
          this[key] = count;
        }
      }, 15); // Adjust speed here
    });
  },
},
  mounted() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
          this.animateCounters(); // Trigger counter animation
        }
      });
    },
    {
      threshold: 0.2, // Adjust for smoother animation trigger
    }
  );

  document.querySelectorAll(".strategic-card").forEach((card) => observer.observe(card));
}
  };
  </script>
  
<style scoped>
  /* Smooth Fade-In Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .animate-fadeIn {
    animation: fadeIn 0.8s ease-out;
  }
  .story-style{
    font-family: "Caveat";
  }
  .strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>